import {
    BASE_URL
} from '../../config';
import {
    GET_B2B_USERS,
    UPDATE_B2B_USER
} from './b2bUsers.actionsTypes';

import axios from 'axios';

export const getB2bUsers = () => {
    return (dispatch) => {
        axios.get(`${BASE_URL}user/b2bUsers/`, {}).then((response) => {
            if (response.data) {
                dispatch({
                    type: GET_B2B_USERS,
                    payload: response.data
                });
            }
        });
    }
};

export const updateB2bUser = (user) => {
    return {
        type: UPDATE_B2B_USER,
        user
    };
};